import React, { useContext, useMemo } from 'react';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import { ProductTransaction, ProductTransactionType } from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { t } from '../../../../../../../../types/translation/Translator';
import { ProductContext } from '../../../../../../../../context/ProductContext';
import { Container } from '../../../../../../../../types/container';
import { TextInput } from '../../../../../../../components/TextInput';

interface ProductTransactionDestinationSerialProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  productMasterData?: ProductMasterData;
  container?: Container;

  disabled?: boolean;
}

export default function ProductTransactionDestinationSerial({
  transaction,
  setTransaction,
  productMasterData,
  container,
  disabled = false,
}: ProductTransactionDestinationSerialProps) {
  if (!productMasterData) return null;

  const { products } = useContext(ProductContext);

  const isDefined = useMemo(() => {
    if (transaction.product.fromProductId && transaction.containerTransactionId) return true;
    return false;
  }, []);

  if (!productMasterData.serialManaged) return null;
  if (transaction.type !== ProductTransactionType.inbound) return null;

  return (
    <Grid item xs={6}>
      <TextInput
        mandatory
        disabled={disabled || isDefined}
        label={t(TranslationKey.serialNumber).singular.label}
        placeholder={t(TranslationKey.serialNumber).singular.label}
        onChange={v => {
          setTransaction(transaction => transaction.withSerial(v));
        }}
        value={transaction.product.serialNbr}
      />
    </Grid>
  );
}
